module.exports = __webpack_public_path__ + "img/glass_brown.b7326978.png";